import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20aerial%20view%20at%20night%20with%20dramatic%20stadium%20lights%20and%20green%20field%2C%20atmospheric%20energy%2C%20professional%20sports%20photography%20style%2C%20wide%20angle%2C%20epic%20cinematic%20lighting%2C%20dark%20moody%20background%20with%20warm%20golden%20accent%20lights&width=1920&height=900&seq=hero-bg-sports&orientation=landscape"
          alt="真人体育 - 沉浸式赛事体验"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65"></div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6 py-16 md:py-20 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-500/20 border border-primary-500/30 rounded-full mb-6">
          <span className="w-2 h-2 bg-primary-500 rounded-full animate-pulse"></span>
          <span className="text-sm text-background-50 font-medium">全球100+赛事实时覆盖</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
          沉浸式真实赛事
          <span className="block text-primary-400">竞猜体验平台</span>
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          真人体育汇聚全球顶级赛事，提供足球、篮球、网球等真实赛事实时竞猜体验。
          赔率透明、数据实时、安全可靠，随时随地享受极致竞猜乐趣。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/football"
            className="px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-all duration-200 text-base no-underline whitespace-nowrap cursor-pointer"
          >
            开始竞猜
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/10 text-background-50 font-semibold rounded-lg border border-background-50/20 hover:bg-background-50/20 transition-all duration-200 text-base no-underline whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="grid grid-cols-3 gap-4 md:gap-8 max-w-2xl mx-auto mt-12">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">100+</p>
            <p className="text-xs md:text-sm text-background-50/60 mt-1">全球赛事覆盖</p>
          </div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-primary-400">500万+</p>
            <p className="text-xs md:text-sm text-background-50/60 mt-1">活跃用户信赖</p>
          </div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">99.9%</p>
            <p className="text-xs md:text-sm text-background-50/60 mt-1">平台安全稳定</p>
          </div>
        </div>
      </div>
    </section>
  );
}